<template>
    <div class="hse-page">
        <!-- Header + Super Admin -->
        <div class="hse-header-row">
            <!-- Header -->
            <div class="hse-header">
                <img src="/../../../assets/layout/images/logo.png" alt="logo" class="hse-logo" />
                <div>
                    <h1 class="hse-title">WELCOME</h1>
                    <p class="hse-subtitle">Bạn đang làm trên phần mềm CSMS</p>
                </div>
            </div>

            <!-- Box dành cho Super Admin -->
            <div v-if="base_admin" class="hse-grid">
                <div class="hse-box" @click="onClickItemModule(base_admin, -1)">
                    <div class="hse-box-left">
                        <img :src="base_admin.image"  class="hse-box-icon image1" />
                    </div>
                    <div class="hse-box-right">
                        <span class="hse-card-title">{{ base_admin.title }}</span>
                        <span class="hse-card-desc">{{ base_admin.desc }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Quick Access -->
        <div class="hse-section">
            <h2 class="hse-section-title">QUICK ACCESS</h2>

            <div class="hse-grid">
                <div v-for="(item, index) in quickAccess" :key="index" class="hse-box"
                    @click="item.is_approved ? onClickItemModule(item, index) : null">
                    <div class="hse-box-left">
                        <img :src="item.image"  class="hse-box-icon image1" />
                        <div v-if="item.is_approved == false" class="hse-box-icon image2">
                            <img :src="lock_url" class="hse-lock"/>
                        </div>
                        
                    </div>
                    <div class="hse-box-right">
                        <span class="hse-card-title">{{ item.title }}</span>
                        <span class="hse-card-desc">{{ item.desc }}</span>
                        <Button
                            v-if="item.is_approved == false"
                            label="Kích hoạt"
                            @click="ActionShowDialogModule(item)"
                            class="p-button-success main-style-button btn-bottom-hse"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showIntroVideo" class="hse-section" style="padding-top: 20px;">
            <h2 class="hse-section-title">HƯỚNG DẪN SỬ DỤNG</h2>

            <div class="hse-video-grid">
                <div class="hse-video-column">
                    <div v-for="(video, index) in videosLeft" :key="index" class="hse-video-item">
                        <iframe controls :src="video.url_watch" class="hse-video-box"></iframe>
                    </div>
                </div>

                <div class="hse-video-column">
                    <div v-for="(video, index) in videosRight" :key="index" class="hse-video-item">
                        <iframe controls :src="video.url_watch" class="hse-video-box"></iframe>
                    </div>
                </div>
            </div>
        </div>
        <Dialog :visible.sync="showDialogModule" id="showDialogModule" :containerStyle="{width: '50vw'}">
            <template #header>
                <span style="font-weight: 600;font-size: 16px;">KÍCH HOẠT</span>
            </template>
            <div>
                <span class="m-0" style="font-size: 14px;">Vui lòng liên hệ số hotline ngay bên dưới để được tư vấn kích hoạt ứng dụng.</span>
            </div>
            <div>
                <span style="font-weight: 500;font-size: 18px;">(+84) XXX XXX XXX</span>
            </div>
            <template #footer>
                <Button label="Quay lại" icon="" @click="showDialogModule = false" class="main-style-button"/>
            </template>
        </Dialog>
    </div>
    
</template>

<script>
import GetConstants from './../../../core/Constants';
var Constants = GetConstants.getConstans();
import ApiRepository from "@/core/ApiRepository";
export default {
    data() {
        return {
            quickAccess: [],
            showDialogModule: false,
            videosLeft: [],
            videosRight: [],
            showIntroVideo: false,
            lock_url : '/../../../assets/layout/images/khoa.png',
            base_admin : null,
        }
    },
    async created() {
		await this.loadModules();
        await this.LoadVideos();
	},
    methods: {
        async onClickItemModule(item, index) {
            // console.log("Bạn click vào:", item, "vị trí:", index)
            if (this.$route.path !== item.url) {
                if(item.is_hse == true){
                    const target = this.$store.getters.companyType === 'option_1' ? '_self' : '_blank';
                    window.open(item.url, target);
                } else {
                    console.log("mở link khóa học", index)
                    // Mở link mới
                    var token = this.$store.getters.token ? this.$store.getters.token : null
                    const headers = {
                    "Authorization": "Bearer "+token,
                    };
                    var that = this;
                    await ApiRepository.post("/_api/users/get_token_kh", {}, {headers}).then(function (res) {
                        // console.log("res====",res.data)
                        var value = res.data.data;
                        var uri = that.$ConfigEvn.base_url_hse_soft +`/sso-login?menu=`+item.hse_soft_role+`&token=`+value.token_callback;
                        // console.log("uri======",uri)
                        window.open(uri, '_blank');
                    });
                }
            }
        },
        async loadModules() {
            // Gọi API lấy danh sách modules
            var token = this.$store.getters.token ? this.$store.getters.token : null
            if(token){
                const headers = {
                    "Authorization": "Bearer "+token,
                };
                var listModule = await ApiRepository.post(Constants.API.MODULE_USER, {}, {headers}).then(function (response) {
                    var data = response?.data?.data ?? [];
                    // console.log('data menu', data);
                    return data
                }).catch(function (error) {
                    console.log('error', error);
                    return []
                });
                var quickAccess_tmp = [];
                if (listModule.length > 0) {
                    //nếu là num_admin = 1 thì thêm vào base_admin
                    for (let i = 0; i < listModule.length; i++) {
                        const element = listModule[i];
                        if (element.num_admin == 1) {
                            this.base_admin = {
                                title: element.name || "No Name",
                                desc: element.description || "",
                                image: element.img_name ? '/../../../assets/layout/images/' + element.img_name : "/../../../assets/layout/images/logo.png",
                                url: element.url || "/#",
                                is_hse: element.is_hse || false,
                                is_approved: element.is_approved || false,
                                hse_soft_role: element.hse_soft_role || "",
                            };
                        }else{
                            quickAccess_tmp.push({
                                title: element.name || "No Name",
                                desc: element.description || "",
                                image: element.img_name ? '/../../../assets/layout/images/' + element.img_name : "/../../../assets/layout/images/logo.png",
                                url: element.url || "/#",
                                is_hse: element.is_hse || false,
                                is_approved: element.is_approved || false,
                                hse_soft_role: element.hse_soft_role || "",
                            });
                        }
                    }
                }
                this.quickAccess = quickAccess_tmp;
            }else{
                // Không có token thì trỏ về trang login
                this.$router.push('/auth/login');
            }
        },
        ActionShowDialogModule(item) {
            console.log("Kích hoạt:", item)
            this.showDialogModule = true;
        },
        async LoadVideos() {
            var listVideo = await ApiRepository.post(Constants.API.LIST_VIDEO, {}, {}).then(function (response) {
                var data = response?.data?.data ?? [];
                // console.log('data menu', data);
                return data
            }).catch(function (error) {
                console.log('error', error);
                return []
            });
            // console.log("listVideo", listVideo)
            var videosLeft_tmp = [];
            var videosRight_tmp = [];
            if (listVideo.length > 0) {
                this.showIntroVideo = true;
                listVideo.forEach((video, index) => {
                    if (index % 2 === 0) {
                        videosLeft_tmp.push(video);
                    } else {
                        videosRight_tmp.push(video);
                    }
                });
            }else{
                this.showIntroVideo = false;
            }
            this.videosLeft = videosLeft_tmp;
            this.videosRight = videosRight_tmp;
        }
    }
}
</script>

<style scoped>
.hse-page {
    min-height: 100vh;
    background: #f9fafb;
    padding: 24px;
    box-sizing: border-box;
}

/* Header row chứa Welcome + Admin */
.hse-header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    /* để xuống hàng khi màn nhỏ */
    margin-bottom: 32px;
}

/* Header (logo + welcome text) */
.hse-header {
    display: flex;
    align-items: center;
}

.hse-logo {
    width: 70px;
    height: 70px;
    margin-right: 12px;
}

.hse-title {
    font-size: 24px;
    font-weight: bold;
    margin: 0;
}

.hse-subtitle {
    color: #4b5563;
    margin: 0;
    font-size: 13px;
}

/* Box chung (Super Admin + Quick Access card) */
.hse-box {
    display: flex;
    flex-direction: row;
    gap: 2px;/* khoảng cách giữa hình và chữ */
    padding: 4px;
    height: 120px;
    cursor: pointer;
    background-color: #ffffff;
    /* thêm viền */
    border: 1px solid #b1b1b1;
}

.hse-box:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.hse-box-icon {
    margin-right: 2px;
}

/* Bên trái: hình */
.hse-box-left {
    display: flex;
    align-items: center;
    /* canh giữa theo chiều dọc */
    justify-content: center;
    width: 80px;
    /* cố định chiều ngang */
    position: relative;
}

.hse-box-left img {
    width: 80px;
    height: 80px;
    object-fit: contain;
    display: block;
}

/* Bên phải: chữ */
.hse-box-right {
    position: relative;       /* để con có thể absolute */
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-top: 10px;
}

.hse-card-title {
    font-weight: 500;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /* nếu dài thì ... */
    font-size: 15px;
}

.hse-card-desc {
    display: -webkit-box;
    -webkit-line-clamp: 2;/* tối đa 2 dòng */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 2px 0 0 0;
    font-size: 12px;
    color: #6b7280;
}


/* Section Title */
.hse-section-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 16px;
}

/* Grid Layout */

.hse-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 16px;
}

.btn-bottom-hse {
    position: absolute;
    bottom: 8px;   /* sát đáy */
    right: 8px;    /* sát phải */
}

.hse-video-grid {
    display: flex;
    gap: 16px; /* khoảng cách giữa 2 cột */
}

.hse-video-column {
    flex: 1; /* mỗi cột chiếm 50% */
    display: flex;
    flex-direction: column;
    gap: 16px; /* khoảng cách giữa các video trong cột */
}

.hse-video-box {
    width: 100%;
    height: 250px; /* hoặc auto nếu muốn giữ tỷ lệ */
    background-color: #000;
}
.hse-box-left .image2 {
    position: absolute;
    left: 0;
    z-index: 1; /* đảm bảo nằm trên image1 */
}
.hse-lock{
    padding: 12px;
    background-color: #00000080;
}
</style>
